/**
 * Normalize a LinkedIn/Unipile employee-count range (`{ from, to }`) into a
 * compact bucket string for storage/display, e.g. {51,200} → "51-200",
 * {10001,null} → "10001+".
 *
 * Returns null unless there is a valid lower bound (a finite count > 0), so a
 * missing / zero / non-finite `from` never produces a malformed bucket like
 * "0-0", "undefined+", or "NaN+". When `to` is missing, non-finite, or below
 * `from`, the bucket is open-ended ("{from}+").
 */
export function formatEmployeeCountRange(
  from: number | null | undefined,
  to: number | null | undefined,
): string | null {
  if (from == null || !Number.isFinite(from) || from <= 0) return null;
  if (to != null && Number.isFinite(to) && to >= from) return `${from}-${to}`;
  return `${from}+`;
}
